/**
 * What the document pipeline accepts, in one place.
 *
 * Mirrors `backend/do-chat-documents/app/format_router.py` (`_EXT`) and
 * `DOCUMENTS_MAX_UPLOAD_BYTES`. The server stays the authority — this exists so
 * a doomed upload fails instantly with a precise reason instead of after a long
 * transfer, and so both file pickers advertise the same set.
 *
 * `frontend/nginx.conf.template` must stay above MAX_UPLOAD_BYTES.
 */
export const MAX_UPLOAD_BYTES = 100 * 1024 * 1024

export const DOCUMENT_EXTENSIONS = [
  'pdf',
  'docx',
  'pptx',
  'xlsx',
  'csv',
  'md',
  'markdown',
  'txt',
]

/** `accept` attribute value. Advisory only — always validate the picked files. */
export const DOCUMENT_ACCEPT = DOCUMENT_EXTENSIONS.map((ext) => `.${ext}`).join(',')

export function fileExtension(name = '') {
  const dot = String(name).lastIndexOf('.')
  return dot > 0 ? String(name).slice(dot + 1).toLowerCase() : ''
}

/** Whether this file belongs in the document pipeline at all (images do not). */
export function isDocumentFile(file) {
  return DOCUMENT_EXTENSIONS.includes(fileExtension(file?.name))
}

export function formatMaxUploadSize() {
  return `${Math.round(MAX_UPLOAD_BYTES / (1024 * 1024))} MB`
}

/** A user-facing reason this file cannot be uploaded, or null if it can. */
export function uploadRejectionReason(file) {
  if (!file) return 'No file selected'
  if (!isDocumentFile(file)) {
    return `${fileExtension(file.name) || 'This file type'} is not supported`
  }
  if (file.size > MAX_UPLOAD_BYTES) return `Larger than the ${formatMaxUploadSize()} limit`
  if (file.size === 0) return 'File is empty'
  return null
}
